export const siteSettings = {
  name: "Cloud Finex",
  link: "https://cloudfinex.pro",
  email: "support@cloudfinex.pro",
  appLink: "https://app.cloudfinex.pro",
};
